import $ from 'jquery';

angular.module("SupportAgent")
.controller(
 'SupportChatController',
 ['$rootScope', '$scope', 'EventHandler', '$timeout',
  'L','INTERACT','INTRACTABLE','$mdDialog',
 function ($rootScope, $scope, EventHandler, $timeout, L,INTERACT,INTRACTABLE,$mdDialog) {
  var mediaConfig;
  function navigate() {
   mediaConfig = {};
   var convo = $rootScope.selected_conversation;
   $scope.messages = convo? convo.m : [];
   $rootScope.send_btn_text = $rootScope.strings.str_send;
   $rootScope.terminalAccessed = true;
   $rootScope.selectedMessageType = $rootScope.messageTypes[0];
   $scope.is_camera_mute = false;
   $rootScope.is_video_opened=false;
   $scope.is_getting_media_in_progress=false;
   $scope.cams={
    front: { strids: {
     accepted: 'str_front_camera_accepted_by_customer',
     rejected: 'str_front_camera_denied_by_customer'
     }
    },
    back: { strids: {
     accepted: 'str_back_camera_accepted_by_customer',
     rejected: 'str_back_camera_denied_by_customer'
     }
    },
   };
  }
  var cam_types={0:$rootScope.strings.str_main_camera,1:$rootScope.strings.str_face_camera};
  var is_mic_mute = false;
  var media_stream=null;
  var incoming_video_call_alert=undefined;
  navigate();
  $scope.$on('$routeChangeSuccess',function(evt,current) {
   if(current.scope.name=='support') navigate();
  });
  $scope.$on('$routeUpdate',function(evt,current) {
   if(current.scope.name=='support') navigate();
  });

  $scope.sendChatMessage = function (content) {
   if(!content) return;
   $scope.transaction.content = null;
   EventHandler.APILAYER.sendMessage({
    convid: +$rootScope.conversationID, channel: INTERACT.D.xaction.channel.chat,
    msg: content,
    devid: +$rootScope.deviceID
   });
  };
  $scope.isSelfMessage = function(acid){
   var $messagebox = $('.nano');
   $messagebox[0].scrollTop = $messagebox[0].scrollHeight;
   return acid==INTERACT.get_myself().id;
  };
  $scope.isDiagMsg = function(chid){
   return (chid == 3);
  };
  $scope.isDiagResMsg = function(chid){
   return (chid == 6);
  };
  $scope.prepareCall=function() {
   navigator.mediaDevices.getUserMedia({audio:true})
   .then(function() {
    $rootScope.is_audio_call_accepted = false;
    if($rootScope.is_in_video_call) {
     $("#btn_video_icon").removeClass("fa-phone-x");
     $("#btn_video_icon").addClass("fa-phone");
     $rootScope.hideIncomingCallAlert();
     $scope.closeVideoChat(true);
    }
    else {
     navigator.mediaDevices.enumerateDevices()
     .then(function(devices) {
       Object.assign(mediaConfig,
        devices.reduce(function(p,c){
         const kind = (''+c.kind).replace(/input$/,'');
         return (p.hasOwnProperty(kind)&&(p[kind]=true)),p;
        }, {video:false,audio:false})
       );
       if(mediaConfig.video||mediaConfig.audio) {
        if(!$rootScope.isDeviceOnline()) {
         $rootScope.getSessionStatus($rootScope.accountID, $rootScope.deviceID,function(e,s) {
          switch(s)
          {
           case 2:
            $rootScope.video_error_message = $rootScope.strings.device_offline_status_logout;
            break;
           case 3:
            $rootScope.video_error_message = $rootScope.strings.device_offline_status_connectionlost;
            break;
           case 4:
            $rootScope.video_error_message = $rootScope.strings.device_offline_status_terminated;
            break;
           default:
            $rootScope.video_error_message="";
          }
          if($rootScope.video_error_message!="") $scope.updateCallStatus($rootScope.video_error_message,0);
         });
        }
        else {
         $rootScope.videoCallTimer = setTimeout( function() {
          $scope.closeVideoChat(true,true);
          $rootScope.getSessionStatus($rootScope.accountID, $rootScope.deviceID,function(e,s) {
           switch(s)
           {
            case 1:
             $rootScope.video_error_message = $rootScope.strings.call_noresponse_status_ongoing;
             break;
            case 2:
             $rootScope.video_error_message = $rootScope.strings.call_noresponse_status_logout;
             break;
            case 3:
             $rootScope.video_error_message = $rootScope.strings.call_noresponse_status_connectionlost;
             break;
            case 4:
             $rootScope.video_error_message = $rootScope.strings.call_noresponse_status_terminated;
             break;
            default:
             $rootScope.video_error_message="";
           }
           if($rootScope.video_error_message!="") $scope.updateCallStatus($rootScope.video_error_message,0);
          });
         }, 30000);
         $("#btn_video_icon").removeClass("fa-phone-x");
         $("#btn_video_icon").addClass("fa-phone-x");
         $rootScope.is_in_video_call=true;
         $scope.updateCallStatus($rootScope.strings.str_ringing,1);
         EventHandler.send_call_request();
         $rootScope.callDetails = {callby:INTERACT.get_myself().id,conversationID:$rootScope.conversationID,
         deviceID:$rootScope.deviceID,callType:"outgoing",callto:$rootScope.accountID,otherside:$rootScope.accountID,cam_permission:{}};
        }
       }
       else{
        $("#btn_video_icon").removeClass("fa-phone-x");
        $("#btn_video_icon").addClass("fa-phone");
        $rootScope.is_in_video_call=false;
        $scope.updateCallStatus($rootScope.strings.str_no_av_device_pc,0);
       }
     })
     .catch(function(err) {
      L.error({err:err},"error enumerating media devices");
     });
    }
   })
   .catch(function(err) {
    $rootScope.is_in_video_call=false;
    switch(err.name) {
     case 'NotAllowedError':
       $scope.updateCallStatus($rootScope.strings.str_agent_denied_audio_permissions,0);
      break;
     case 'NotFoundError':
       $scope.updateCallStatus($rootScope.strings.str_failed_to_detect_audio_devices,0);
      break;
    }
   });
  };
  $scope.$on('video-response', function (event,data) {
   if($rootScope.videoCallTimer) clearTimeout($rootScope.videoCallTimer);
   // TODO there's a copypaste below, marked with "1553980282"
   // TODO: aren't those checked conditions severe errors we should be aware of?
   var account = INTERACT.get_account($rootScope.accountID);
   var p = account && account.get_profile();
   var un=p?(p.first_name||p.last_name||$rootScope.strings.str_user):$rootScope.strings.str_user;
   $scope.otherSide = data.by;
   if(data.accept){
    $rootScope.callDetails.startTime = Math.round(new Date().getTime()/1000);
    $rootScope.getMedia({audio:true},function(e,s) {
     if(e) {
      $rootScope.video_error_message = $rootScope.strings.str_check_av_input;
      $scope.updateCallStatus($rootScope.video_error_message,0);
      $("#btn_video_icon").removeClass("fa-phone-x");
      $("#btn_video_icon").addClass("fa-phone");
      $rootScope.is_in_video_call=false;
      EventHandler.APILAYER.sendMessage({
       convid: $rootScope.conversationID,
       channelid: INTERACT.D.xaction.channel.videochat,
       msg: JSON.stringify({
        type:'video-response',accept:false,reason:'not-possible',
        by:INTERACT.get_myself().id, to:+$rootScope.accountID
       }),
       devid: +$rootScope.deviceID,
       validity: 5000
      });
      return;
     }
     $scope.updateCallStatus($rootScope.strings.str_call_accept_by+un,1);
     document.getElementById('localVideo').srcObject = s;
     $rootScope.isAudioCall=true;
     $rootScope.callDetails.client_call_status='str_video_info_in_audio_call';
     $scope.$apply();
     $rootScope.start_call(s);
     $('#videocall-modal').fadeIn();
    });
   }
   else {
    var msg="";
    var cs=data.call_status;
    var chf=data.hidden_feature;
    if(chf) msg=$rootScope.strings.str_feature_not_supported;
    else if(cs) msg=!cs.audio?$rootScope.strings.str_client_deny_audio_permission:$rootScope.strings.str_client_deny_video_permission;
    else msg=WTG.fmt($rootScope.getString('str_user_call_rejected'),{un:un});
    $rootScope.appendMessageToHistory({
     convid: $rootScope.conversationID, acid: $rootScope.accountID,
     display_name: "",
     msg: msg,
     msgtime: new Date(),
     channelid: INTERACT.D.xaction.channel.videochat,
     convstatus: INTERACT.D.conversation.status.ongoing
    });
    if(!$rootScope.is_audio_call_accepted) {
     $rootScope.video_error_message = chf?$rootScope.strings.str_feature_not_supported:WTG.fmt($rootScope.getString(cs?'str_call_cancelled_no_permissions':'str_user_call_rejected'),{un:un});
     $scope.updateCallStatus($rootScope.video_error_message,0);
     $("#btn_video_icon").removeClass("fa-phone-x");
     $("#btn_video_icon").addClass("fa-phone");
     $rootScope.is_in_video_call=false;
    }
   }
  });
  $scope.$on('video-close', function (/*event,data*/) {
   $scope.closeVideoChat(false);
  });

  ['front','back'].forEach(function(cam) {
   $scope.$on('wtg.wrtc.camera.'+cam+'.response', function (evt,data) {
    if(data.accept) $rootScope.callDetails.stream_name=cam;
    if(!$rootScope.callDetails.cam_permission[cam]) $rootScope.appendMessageToHistory({
      convid: $rootScope.callDetails.conversationID,
      acid: $rootScope.callDetails.otherside,
      msg: $rootScope.strings[$scope.cams[cam].strids[data.accept?'accepted':'rejected']],
      msgtime: new Date(),
      channelid: INTERACT.D.xaction.channel.videochat
    });
    $rootScope.callDetails.cam_permission[cam]=data.accept;
    $rootScope.callDetails.is_video_offer_allowed=data.accept;
   });
  });

  $rootScope.closeVideoChat=function(send,skipStatusUpdate) {
   if($rootScope.videoCallTimer) clearTimeout($rootScope.videoCallTimer);
    $("#btn_video_icon").removeClass("fa-phone-x");
    $("#btn_video_icon").addClass("fa-phone");
    $rootScope.is_in_video_call=false;
    $rootScope.video_icon = $rootScope.videoCallImages.camera_un_mute_icon;
    $rootScope.mic_icon = $rootScope.videoCallImages.mic_mute_icon;
    is_mic_mute=false;
    $rootScope.is_audio_call_accepted=false;
    $rootScope.btnVideoCallDisable = false;
    $rootScope.hideIncomingCallAlert();
    if(send) EventHandler.APILAYER.sendMessage({
     convid: +$rootScope.callDetails.conversationID,
     channelid: INTERACT.D.xaction.channel.videochat,
     msg: JSON.stringify({
      by: INTERACT.get_myself().id,
      to: +$rootScope.callDetails.otherside,
      type:'video-close' }),
     devid: +$rootScope.callDetails.deviceID,
     validity: 5000
    });
    var message = "";
    if($rootScope.callDetails.startTime) {
     $rootScope.callDetails.endTime = Math.round(new Date().getTime()/1000);
     message = $rootScope.prepareCallDuration($rootScope.callDetails.startTime, $rootScope.callDetails.endTime, $rootScope.callDetails.callby);
    }
    else {
     // TODO there's a copypaste above, marked with "1553980282"
     // TODO: aren't those checked conditions severe errors we should be aware of?
     var account = INTERACT.get_account($rootScope.accountID);
     var p = account && account.get_profile();
     var un=p?(p.first_name||p.last_name||$rootScope.strings.str_user):$rootScope.strings.str_user;
     message =  send? $rootScope.strings.str_agent_closes_call:WTG.fmt($rootScope.getString('str_user_ended_call'),{un:un});
    }
    if(!skipStatusUpdate) $scope.updateCallStatus(message,1);
    $rootScope.appendMessageToHistory({
     convid: $rootScope.callDetails.conversationID, acid: send?INTERACT.get_myself().id:$rootScope.accountID,
     msg: message, msgtime: new Date(),
     channelid: INTERACT.D.xaction.channel.videochat
    });
    if(incoming_video_call_alert) $mdDialog.hide(incoming_video_call_alert, "finished");
    incoming_video_call_alert=undefined;
    $('#videocall-modal').fadeOut();
    $rootScope.is_video_opened=false;
    $rootScope.callDetails = {};
    $rootScope.is_call_with_other_ticket=false;
    if(media_stream) media_stream.getTracks().forEach(function(track) {
     track.stop();
    });
    media_stream=null;
    EventHandler.closeWRTC();
  };

  $scope.sendMessage = function(content) {
   switch($rootScope.selectedMessageType.type)
    {
     case 'Chat':
      $scope.sendChatMessage(content);
      break;
     case 'Terminal':
      {
        var b = $rootScope.checkTerminalAccessPermission($rootScope.deviceID);
        var message = "";
        var ctext = "";
        if($scope.transaction) $scope.transaction.content = null;
        var conid = +$rootScope.conversationID;
        if(!b) {
         var tap = $rootScope.terminalAccessPermissions.find(function(x){return x.did==$rootScope.deviceID});
         var timer = setTimeout(function() {
          var tap = $rootScope.terminalAccessPermissions.find(function(x){return x.timerid==timer});
          tap.btn_disable=false;
          if(tap.did==$rootScope.deviceID) $rootScope.disable_send_btn = false;
          $timeout(function(){$scope.$apply()},0);
         },60000);
         if(!tap) {
          var o = {did:$rootScope.deviceID,grant:false,btn_disable:true,timerid:timer};
          $rootScope.terminalAccessPermissions.push(o);
         }else {
          tap.btn_disable=true;
          tap.timerid=timer;
         }
         $rootScope.disable_send_btn=true;
         ctext = "confirmation";
         message  = $rootScope.getString('str_terminal_request_to_device');
        }
        else {
         ctext = content;
         message  = WTG.fmt($rootScope.getString('str_terminal_command'),{command:content});
        }
        EventHandler.APILAYER.sendMessage({
         convid: conid,
         channelid: INTERACT.D.xaction.channel.diagreq,
         msg: "7|command|"+ctext,// TODO: magic
         devid: +$rootScope.deviceID
        });
        $rootScope.appendMessageToHistory({
         convid: $rootScope.conversationID, acid: $rootScope.getAccountID($rootScope.conversationID),
         display_name: "",
         msg: message, msgtime: new Date(),
         channelid: INTERACT.D.xaction.channel.diagreq,
         convstatus: INTERACT.D.conversation.status.ongoing
        });
        $timeout(function() {
         $scope.$apply();
        }, 0);
       }
       break;
     case 'Push Notification':
      {
        if(!content) return;
        if($scope.transaction) $scope.transaction.content = null;
        INTRACTABLE.request("notify", {
         "did": +$rootScope.deviceID,
         'm':content},
         function(e, r) {
          if(e) L.error({err:e},"failed to submit push notification");
          if(r._S!='ok') L.error({r:r},"failed to submit push notification");
          var status = e?'failed':'sent';
          $rootScope.showToasterMsg(!e?'success':'error',content,WTG.fmt($rootScope.getString('str_notification_status'),{status:status}));
        });
      }
      break;
     default:
      L.warn({mt:$rootScope.selectedMessageType},'unknown messagetype '+$rootScope.selectedMessageType);
    }
  };
  $rootScope.toggle_video_layer = function() {
   if($rootScope.callDetails.currentStream) $rootScope.callDetails.currentStream.getTracks().forEach(function(t){t.stop()});
   if($scope.is_getting_media_in_progress) return L.trace('Getting user media is in progress');
   if(!$rootScope.callDetails.is_video_allowed) {
    navigator.mediaDevices.getUserMedia({video:true})
    .then(function(stream) {
     media_stream=stream;
     $rootScope.video_icon = $rootScope.callDetails.is_video_allowed?$rootScope.videoCallImages.camera_un_mute_icon:
     $rootScope.videoCallImages.camera_mute_icon;
     document.getElementById("localVideo").style.display = $rootScope.callDetails.is_video_allowed?"none":"block";
     EventHandler.APILAYER.sendMessage({
      convid: +$rootScope.callDetails.conversationID,
      channelid: INTERACT.D.xaction.channel.videochat,
      msg: JSON.stringify({
       type: 'video-offer-request',
       by:INTERACT.get_myself().id, to:+$rootScope.callDetails.otherside
      }),
      devid: +$rootScope.callDetails.deviceID,
      validity: 5000
     });
    })
    .catch(function(err) {
     switch(err.name) {
      case 'NotAllowedError':
       $scope.updateCallStatus($rootScope.strings.str_agent_denied_video_permissions,0);
       break;
      case 'NotFoundError':
       $scope.updateCallStatus($rootScope.strings.str_failed_to_detect_video_devices,0);
       break;
      }
    });
   }
   else {
    EventHandler.APILAYER.sendMessage({
     convid: +$rootScope.callDetails.conversationID,
     channelid: INTERACT.D.xaction.channel.videochat,
     msg: JSON.stringify({
      type: 'media-change',
      by:INTERACT.get_myself().id, to:+$rootScope.callDetails.otherside,is_cam:false
     }),
     devid: +$rootScope.callDetails.deviceID,
     validity: 5000
    });
    $scope.is_getting_media_in_progress=false;
    $rootScope.callDetails.is_video_allowed=false;
    $rootScope.video_icon = $rootScope.videoCallImages.camera_un_mute_icon;
    EventHandler.WRTC.removeTrack($rootScope.callDetails.otherside,'video');
    if(media_stream) media_stream.getTracks().forEach(function(track) {
     track.stop();
    });
   }
   $rootScope.$applyAsync();
  };

  $rootScope.muteAudioMic = function() {
   $rootScope.mic_icon = is_mic_mute?$rootScope.videoCallImages.mic_mute_icon:$rootScope.videoCallImages.mic_un_mute_icon;
   EventHandler.WRTC.switchStream(is_mic_mute,'Audio',$rootScope.callDetails.otherside);
   is_mic_mute=!is_mic_mute;
  };
  $scope.hideresults=true;
  $scope.resultfilter = function resultfilter(h) {
   return function resultfilter(m) {
    return m && m.msg &&
    (h?m.ch<INTERACT.D.xaction.channel.diagreq:m.ch>=INTERACT.D.xaction.channel.chat);
   };
  };
  $scope.$on('wtg.wrtc.video-offer-response', function (event,data) {
   $scope.otherSide=data.by;
   if(data.accept) {
    EventHandler.APILAYER.sendMessage({
     convid: $rootScope.callDetails.conversationID,
     channelid: INTERACT.D.xaction.channel.videochat,
     msg: JSON.stringify({
      type: 'media-change',
      by:INTERACT.get_myself().id, to:$rootScope.callDetails.otherside,is_cam:true
     }),
     devid: +$rootScope.callDetails.deviceID,
     validity: 5000
    });
    var cnf={audio:true,video:!$rootScope.callDetails.is_video_allowed};
    $scope.is_getting_media_in_progress=true;
    $rootScope.callDetails.is_video_allowed=true;
    $rootScope.getMedia(cnf,function(e,stream) {
     document.getElementById('localVideo').srcObject = stream;
     document.getElementById('localVideo').play();
     var vt = stream.getVideoTracks()[0];
     if(vt) EventHandler.WRTC.addTrack($rootScope.callDetails.otherside,vt);
     $rootScope.callDetails.currentStream=stream;
     $scope.is_getting_media_in_progress=false;
    });
   }
   else $rootScope.video_icon=$rootScope.videoCallImages.camera_un_mute_icon;
   $rootScope.appendMessageToHistory({
    convid: $rootScope.callDetails.conversationID, acid: $rootScope.callDetails.otherside,
    msg: data.accept?$rootScope.strings.str_customer_accepted_video_support:
    $rootScope.strings.str_customer_denied_video_support,
    msgtime: new Date(),
    channelid: INTERACT.D.xaction.channel.videochat
   });
   $scope.$applyAsync(function(){});
  });
  $scope.sendVideoCallMessage = function(type) {
   EventHandler.APILAYER.sendMessage({
    convid: $rootScope.callDetails.conversationID,
    channelid: INTERACT.D.xaction.channel.videochat,
    msg: JSON.stringify({
     type: type,
     by:INTERACT.get_myself().id, to:+$rootScope.callDetails.otherside
    }),
    devid: +$rootScope.callDetails.deviceID,
    validity: 5000
   });
  };
  $scope.$on('wtg.wrtc.video-stream-request', function (/*event,data*/) {
   if($rootScope.callDetails.is_video_offer_allowed) return $rootScope.sendVideoOfferResponse(true);
   incoming_video_call_alert = $mdDialog.confirm({
    parent:document.getElementById("videocallmodal"),
    textContent:$rootScope.strings.str_incoming_video_call_from_customer,
    ok:$rootScope.strings.str_btn_accept,
    cancel:$rootScope.strings.str_btn_reject
   });
   $mdDialog.show(incoming_video_call_alert)
    .finally(function() {
     incoming_video_call_alert=undefined;
    }).then(function() {
     $rootScope.sendVideoOfferResponse(true);
    },function() {
     $rootScope.sendVideoOfferResponse(false);
   });
   $('#videocall-modal').fadeIn();
  });
  $scope.$on('wtg.wrtc.meida-change', function (event,data) {
   if(data.is_cam&&data.hasOwnProperty("cam")) {
    document.getElementById("lbl_cam_indicator").innerText=cam_types[data.cam]||$rootScope.strings.str_cam_unknown;
    $('#videocall-modal').fadeIn();
    $rootScope.callDetails.stream_name = ["back","front"][data.cam]||"unknown";
    $rootScope.callDetails.client_call_status="";
   }
   else {
    $rootScope.callDetails.is_video_offer_allowed=false;
    document.getElementById("lbl_cam_indicator").innerText="";
    $rootScope.callDetails.client_call_status=data.is_on_hold?'str_call_hold_status':'str_video_info_in_audio_call';
    document.getElementById('remoteVideo').srcObject.getVideoTracks().forEach(t => t.stop());
   }
  });
  $scope.$on('wtg.wrtc.call-interrupted', function (/*event,data*/) {
   $rootScope.appendMessageToHistory({
    convid: $rootScope.callDetails.conversationID, acid: $rootScope.callDetails.otherside,
    msg: $rootScope.strings.str_call_interrupted_status,
    msgtime: new Date(),
    channelid: INTERACT.D.xaction.channel.videochat
   });
   $scope.closeVideoChat(false,true);
   $scope.updateCallStatus($rootScope.strings.str_call_interrupted_status,0);
  });
  $rootScope.sendVideoOfferResponse = function(allow) {
   if(!($rootScope.callDetails&&$rootScope.callDetails.conversationID)) return;
   EventHandler.APILAYER.sendMessage({
    convid: $rootScope.callDetails.conversationID, channelid: INTERACT.D.xaction.channel.videochat,
    msg: JSON.stringify({type:'video-stream-response', accept:allow,
    by:INTERACT.get_myself().id,to:$rootScope.callDetails.otherside}),
    devid: +$rootScope.callDetails.deviceID, validity: 5000
   });
   $rootScope.callDetails.incoming_video_call=false;
   $rootScope.callDetails.is_video_offer_allowed=allow;
  };
  $("#videocall-overlay-close").click(function(){
   $("#videocall-modal").fadeOut();
   EventHandler.APILAYER.sendMessage({
    convid: $rootScope.callDetails.conversationID,
    channelid: INTERACT.D.xaction.channel.videochat,
    msg: JSON.stringify({
     type: 'media-change',
     by:INTERACT.get_myself().id, to:+$rootScope.callDetails.otherside,is_cam:false
    }),
    devid: +$rootScope.callDetails.deviceID,
    validity: 5000
   });
   if($rootScope.callDetails.currentStream) $rootScope.callDetails.currentStream.getTracks().forEach(function(t){t.stop()});
   if($rootScope.callDetails.is_video_allowed) {
    $rootScope.callDetails.is_video_allowed=false;
    $rootScope.video_icon=$rootScope.videoCallImages.camera_un_mute_icon;
    EventHandler.WRTC.removeTrack(+$rootScope.callDetails.otherside,'video');
   }
   document.getElementById("lbl_cam_indicator").innerText="";
   $rootScope.callDetails.is_video_offer_allowed=false;
   $rootScope.$applyAsync(function(){
    $rootScope.callDetails.is_overlay_closed=true;
   });
  });
  $scope.showVideocallOverlay=function() {
   $("#videocall-modal").fadeIn();
   $rootScope.callDetails.is_overlay_closed=false;
  };

  $rootScope.takeScreenshot = function() {
   var video = document.getElementById('remoteVideo');
   var width = video.videoWidth;
   var height = video.videoHeight;
   if(!(width&&height)) return L.error("no video stream to capture");
   var now = new Date();
   var timestamp = new Date(now-60000*now.getTimezoneOffset()).toJSON().split('.')[0].replace(/\D+/g,'');
   var image_name = "Ticket "+$rootScope.callDetails.conversationID + " " + timestamp;
   var canvas = document.getElementById('remoteScreenshotCanvas');
   canvas.width = width;
   canvas.height = height;
   var context = canvas.getContext('2d');
   context.drawImage(video, 0, 0, width, height);
   canvas.toBlob(function(blob) {
    saveAs(blob, image_name+".png");
   });
 };
 function show_no_more_transactions_status() {
  var div=$('#no_more_transactions_status');
  div.css('opacity','1');
  $('#load_more_transactions_status').css('display','none');
  setTimeout(div.css.bind(div,'opacity','0'), 4000);
 }
 $scope.fetch_old_transactions = function() {
  var convo = $rootScope.selected_conversation;
  $('#load_more_transactions_status').css('display','none');
   if(!(convo&&convo.timeline)||convo.timeline.retrieved)
    return show_no_more_transactions_status();
   if(!convo.timeline.has_pending_req) {
    convo.timeline.has_pending_req=true;
    $rootScope.retrievedTransactions({convid:$rootScope.conversationID},function(e,r) {
     convo.timeline.has_pending_req=false;
     if(r&&r.count==0) show_no_more_transactions_status();
    });
   }
 };
 $("#transactionsContainer").scroll(function(){
  if($(this).scrollTop() === 0){
    $scope.fetch_old_transactions();
  }
 });
}]);
/* vim:set ts=8 sw=1 expandtab: */
